export const stripAllBlanks = (value = '') => value.replace(/\s/g, '');
export const stripNonNumbers = (value = '') => value.replace(/\D/g, '');
export const stripRepeatedZeros = (value = '') => value.replace(/^0+/, '0');
